var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _feBlend, _feBlend2, _mask, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#646464;}\r\n\t.st1{fill:url(#path1948_1_);}\r\n\t.st2{fill:url(#path1950_1_);}\r\n\t.st3{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_1_);}\r\n\t.st5{mask:url(#path1894_2_);fill:url(#path1894_3_);}\r\n\t.st6{opacity:0.4438;fill:url(#path1894_4_);enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "g2303"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "st0",
    d: "M204.5,242c0-11.3-3.2-17.2-9.7-17.5c-2.6-0.1-5.1,0.3-7.5,1.2c-2,0.7-3.3,1.4-4,2.1v27.1 c4.1,2.6,7.8,3.8,11,3.6C201.1,258.1,204.5,252.6,204.5,242z M212.5,242.5c0,5.8-1.4,10.6-4.1,14.4c-3,4.3-7.2,6.5-12.6,6.6 c-4,0.1-8.2-1.1-12.5-3.8v24.6l-6.9-2.5v-54.6c1.1-1.4,2.6-2.6,4.4-3.6c4.1-2.4,9.2-3.6,15.1-3.7l0.1,0.1c5.4-0.1,9.6,2.1,12.5,6.6 C211.1,230.7,212.5,236,212.5,242.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "st0",
    d: "M254.9,258.7c0,7.7-0.8,13.1-2.3,16.1c-1.6,3-4.5,5.4-8.9,7.1c-3.5,1.4-7.4,2.2-11.5,2.3l-1.1-4.4 c4.2-0.6,7.1-1.1,8.8-1.7c3.4-1.1,5.7-2.9,6.9-5.2c1-1.9,1.5-5.5,1.5-10.9v-1.8c-4.7,2.2-9.7,3.2-14.9,3.2c-3.4,0-6.4-1.1-9-3.2 c-2.9-2.3-4.4-5.3-4.4-8.9v-28.9l6.9-2.4V249c0,3.1,1,5.5,3,7.2c2,1.7,4.6,2.5,7.8,2.4c3.2-0.1,6.6-1.3,10.2-3.7v-33.9h6.9V258.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "st0",
    d: "M282,263.1c-0.8,0.1-1.6,0.1-2.3,0.1c-3.9,0-7-0.9-9.2-2.8c-2.2-1.9-3.3-4.5-3.3-7.8v-27.3h-4.8 v-4.4h4.8v-11.6l6.9-2.5v14.1h7.8v4.4h-7.8v27.2c0,2.6,0.7,4.5,2.1,5.5c1.2,0.9,3.1,1.4,5.7,1.5V263.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "st0",
    d: "M324.1,262.5h-6.9v-26.8c0-2.7-0.6-5.1-1.9-7c-1.5-2.2-3.5-3.3-6.1-3.3c-3.2,0-7.2,1.7-11.9,5 v32.1h-6.9v-64.1l6.9-2.2v29.2c4.4-3.2,9.3-4.8,14.5-4.8c3.7,0,6.7,1.2,8.9,3.7c2.3,2.5,3.4,5.5,3.4,9.2V262.5L324.1,262.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "st0",
    d: "M361,240.9c0-4.4-0.8-8-2.5-10.8c-2-3.5-5-5.3-9.1-5.5c-7.6,0.4-11.4,5.9-11.4,16.3 c0,4.8,0.8,8.8,2.4,12c2,4.1,5.1,6.1,9.2,6C357.1,259,361,252.9,361,240.9z M368.6,241c0,6.2-1.6,11.4-4.8,15.5 c-3.5,4.6-8.3,6.9-14.4,6.9c-6.1,0-10.8-2.3-14.3-6.9c-3.1-4.1-4.7-9.3-4.7-15.5c0-5.8,1.7-10.7,5-14.7c3.5-4.2,8.2-6.4,14-6.4 s10.5,2.1,14.1,6.4C366.9,230.2,368.6,235.1,368.6,241z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path56",
    className: "st0",
    d: "M408.4,262.5h-6.9v-28.3c0-3.1-0.9-5.5-2.8-7.3c-1.9-1.7-4.4-2.6-7.5-2.5 c-3.3,0.1-6.4,1.1-9.4,3.2v34.9h-6.9v-35.7c4-2.9,7.7-4.8,11-5.7c3.2-0.8,6-1.2,8.4-1.2c1.6,0,3.2,0.2,4.7,0.5 c2.7,0.6,4.9,1.8,6.7,3.5c1.9,1.9,2.9,4.2,2.9,6.8V262.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path1948_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.2906,
    y1: 138.7071,
    x2: 213.2489,
    y2: 65.6119,
    gradientTransform: "matrix(0.5625 0 0 -0.568 -9.2879 280.0263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A9FD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#306998"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path1948",
    className: "st1",
    d: "M107.8,198.8c-3.6,0-7,0.3-10,0.9c-8.8,1.6-10.4,4.8-10.4,10.9v8h20.9v2.7H87.4h-7.8 c-6.1,0-11.4,3.6-13.1,10.6c-1.9,8-2,12.9,0,21.2c1.5,6.2,5,10.6,11.1,10.6h7.2V254c0-6.9,6-13,13.1-13h20.9 c5.8,0,10.4-4.8,10.4-10.6v-19.9c0-5.7-4.8-9.9-10.4-10.9C115.1,199,111.4,198.7,107.8,198.8z M96.5,205.2c2.2,0,3.9,1.8,3.9,4 c0,2.2-1.8,4-3.9,4c-2.2,0-3.9-1.8-3.9-4C92.6,206.9,94.3,205.2,96.5,205.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path1950_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.0929,
    y1: 21.3782,
    x2: 215.756,
    y2: 64.2996,
    gradientTransform: "matrix(0.5625 0 0 -0.568 -9.2879 280.0263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD43B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE873"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path1950",
    className: "st2",
    d: "M131.7,221.1v9.3c0,7.2-6.1,13.2-13.1,13.2H97.8c-5.7,0-10.4,4.9-10.4,10.6v19.9 c0,5.7,4.9,9,10.4,10.6c6.6,1.9,13,2.3,20.9,0c5.3-1.5,10.4-4.6,10.4-10.6v-8h-20.9v-2.7h20.9h10.4c6.1,0,8.3-4.2,10.4-10.6 c2.2-6.5,2.1-12.8,0-21.2c-1.5-6-4.4-10.6-10.4-10.6H131.7z M120,271.5c2.2,0,3.9,1.8,3.9,4c0,2.2-1.8,4-3.9,4 c-2.2,0-3.9-1.8-3.9-4C116.1,273.2,117.8,271.5,120,271.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "text3004",
    className: "st0",
    d: "M421.9,214.7h1.2v-7.6h2.9v-0.9h-7v0.9h2.9V214.7 M427.1,214.7h1v-7l2.3,7h1.2l2.4-6.9v6.9h1.1 v-8.5h-1.5l-2.6,7.3l-2.2-7.3h-1.7V214.7"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 80.5,
    y: 292.8,
    width: 56,
    height: 10.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 80.5,
    y: 292.8,
    width: 56,
    height: 10.9,
    id: "path1894_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 80.5,
    y: 292.8,
    width: 56,
    height: 10.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 80.5,
    y: 292.8,
    width: 56,
    height: 10.9,
    id: "path1894_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_",
    className: "st4"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path1894_3_",
    cx: -616.0436,
    cy: 324.7637,
    r: 22.6292,
    gradientTransform: "matrix(0 -0.2399 -1.0547 0 451.0249 150.4751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F7F7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path1894_1_",
    className: "st5",
    d: "M136.5,298.3c0,3-12.5,5.4-28,5.4s-28-2.4-28-5.4c0-3,12.5-5.4,28-5.4 S136.5,295.3,136.5,298.3z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path1894_4_",
    cx: -616.0436,
    cy: 324.7637,
    r: 22.6292,
    gradientTransform: "matrix(0 -0.2399 -1.0547 0 451.0249 150.4751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F7F7F"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path1894",
    className: "st6",
    d: "M136.5,298.3c0,3-12.5,5.4-28,5.4s-28-2.4-28-5.4c0-3,12.5-5.4,28-5.4S136.5,295.3,136.5,298.3z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.441fb91d8cb3b0b5324d2f537e4fc9aa.svg";
export { ForwardRef as ReactComponent };